import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      display: 'flex',
      alignItems: 'center',
      margin: theme.spacing(0, 0, -0.6),
      gap: theme.spacing(1),

      '& > .MuiIconButton-root': {
        marginLeft: '-1.4rem',
      },

      '& > h3': {
        fontSize: '2.2rem',
      },
    },
  }),
)
